import { Suspense, lazy } from 'react';
import ErrorBoundary from '../common/error-boundary/error-boundary';
import { injectReducer } from '../root-reducer';
import rootStore from '../store';

const Home = lazy(() => import('./home/home'));
const FreeMaterialsLanding = lazy(() => import('./free-materials-landing/free-materials-landing'));
const Seller = lazy(() => import('./seller'));
const Jobs = lazy(() => import('./builder-landings/jobs/jobs'));
const LMPHistory = lazy(() => import('./builder-landings/lmp-history/lmp-history'));
const schoolAccount = lazy(() => import('./builder-landings/school-account/school-account'));
const SchoolCreate = lazy(() => import('./school-create/school-create'));
const Magazine = lazy(() => import('./builder-landings/magazine/magazine'));
const ReferralsLanding = lazy(() => import('./referrals-landing/referrals-landing'));
const ReferralsLandingForUnauthorized = lazy(() =>
    import('./builder-landings/referrals-landing-for-unauthorized/referrals-landing-for-unauthorized')
);
const Wizard = lazy(() => import('./cabinet/material-wizard/material-wizard'));
const InvoiceInfo = lazy(() => import('./cabinet/settings/invoice-info/invoice-info'));
const ChangePassword = lazy(() => import('./cabinet/settings/change-password/change-password'));
const MentalHealthLanding = lazy(() => import('./builder-landings/mental-health-landing/mental-health-landing'));
const MentalHealthKidsLanding = lazy(() =>
    import('./builder-landings/mental-health-landing/mental-health-kids-landing')
);
const MentalHealthSurvey = lazy(() => import('./builder-landings/mental-health-landing/mental-health-survey'));
const RussiaAttacksUkraineLanding = lazy(() =>
    import('./builder-landings/russia-attacks-ukraine/russia-attacks-ukraine')
);
const ClimateAction = lazy(() => import('./builder-landings/climate-action/climate-action'));
const DonateUkraine = lazy(() => import('./builder-landings/donate-ukraine/donate-ukraine'));
const Inclusion = lazy(() => import('./builder-landings/inclusion/inclusion'));
const BuilderPreview = lazy(() => import('./builder-landings/builder-preview/builder-preview'));
const InteractiveMainLanding = lazy(() => import('./builder-landings/interactive-main/interactive-main'));
const ChangeEmail = lazy(() => import('./cabinet/settings/change-email/change-email'));
const ChangeCountry = lazy(() => import('./cabinet/settings/change-country/change-country'));
const BankDetails = lazy(() => import('./cabinet/settings/bank-details/bank-details'));
const MyUploads = lazy(() => import('./cabinet/sales/my-uploads/my-uploads'));
const CreditNotes = lazy(() => import('./cabinet/sales/credit-notes/credit-notes'));
const Credits = lazy(() => import('./cabinet/sales/credits/credits'));
const Vouchers = lazy(() => import('./cabinet/sales/vouchers/vouchers'));
const MySales = lazy(() => import('./cabinet/sales/my-sales/my-sales'));
const Charts = lazy(() => import('./cabinet/sales/charts/charts'));
const DownloadsList = lazy(() => import('./cabinet/bought-materials/downloads-list/downloads-list'));
const SchoolWishlist = lazy(() => import('./school-wishlist/school-wishlist'));
const InvoicesAndTaxes = lazy(() => import('./cabinet/bought-materials/invoices-and-taxes/invoices-and-taxes'));
const Uploads = lazy(() => import('./cabinet/sales/my-uploads/my-uploads'));
const PreferenceCenter = lazy(() => import('./cabinet/preference-center/preference-center'));
const AutoLogin = lazy(() => import('./auto-login/auto-login'));
const SearchResult = lazy(() => import('./search-result/search-result'));
const Partners = lazy(() => import('./builder-landings/partners/partners'));
const SummerHolidays = lazy(() => import('./builder-landings/summer-holidays/summer-holidays'));
const Author = lazy(() => import('./author/author'));
const OurTeam = lazy(() => import('./builder-landings/our-team/our-team'));
const MobileAppLanding = lazy(() => import('./builder-landings/mobile-app-landing/mobile-app-landing'));
const Blogpost = lazy(() => import('./blogpost/blogpost'));
const CreateBlogpost = lazy(() => import('./create-blogpost/create-blogpost'));
const Recommendations = lazy(() => import('./recommendations/recommendations'));
const Landing = lazy(() => import('./landing/landing'));
const KeywordLanding = lazy(() => import('./keyword-landing-page/keyword-landing-page'));
const NewLanding = lazy(() => import('./new-landing/new-landing'));
const SwitchLandingComponent = lazy(() => import('./switch-landing-component/switch-component'));
const NewMaterialPage = lazy(() => import('./new-material-page/new-material-page'));
const MaterialFeedback = lazy(() => import('./material-feedback/material-feedback'));
const MaterialCardPreview = lazy(() => import('./material-card-preview/material-card-preview'));
const ImpactPage = lazy(() => import('./impact-page/impact-page'));
const Cart = lazy(() => import('./cart/cart'));
const Payment = lazy(() => import('./payment'));
const ThankYouPage = lazy(() => import('./thank-you-page/thank-you-page'));
const ThankYouPageInvoice = lazy(() => import('./thank-you-page/thank-you-page-invoice'));
const SellerSteps = lazy(() => import('./seller-steps/seller-steps'));
const SignIn = lazy(() => import('./sign-in/sign-in'));
const SignUp = lazy(() => import('./sign-up/sign-up'));
const SignUpConfirm = lazy(() => import('./sign-up-confirm/sign-up-confirm'));
const ChangeEmailConfirm = lazy(() => import('./change-email-confirm/change-email-confirm'));
const Fonts = lazy(() => import('./cabinet/tools/fonts'));
const HelpCenter = lazy(() => import('./help-center/help-center'));
const Contact = lazy(() => import('./info/contact/contact'));
const Impressum = lazy(() => import('./info/impressum/impressum'));
const Agb = lazy(() => import('./info/agb/agb'));
const GdprJobs = lazy(() => import('./info/gdpr-jobs/gdpr-jobs'));
const ForgotPassword = lazy(() => import('./forgot-password/forgot-password'));
const Favorites = lazy(() => import('./favorites/favorites'));
const Unsubscribe = lazy(() => import('./unsubscribe/unsubscribe'));
const MailingUnsubscribe = lazy(() => import('./mailing-unsubscribe/mailing-unsubscribe'));
const Api = lazy(() => import('./api/api'));
const AuthorRedirect = lazy(() => import('./author-redirect/author-redirect'));
const MicrosoftRedirectURI = lazy(() => import('./microsoft-redirect-uri/microsoft-redirect-uri'));
const AbandonedCartRedirect = lazy(() => import('./abandoned-cart-redirect/abandoned-cart-redirect'));
const FillPersonalizationRedirect = lazy(() => import('./fill-personalization-redirect/fill-personalization-redirect'));
const UnsubscribeAuthor = lazy(() => import('./unsubscribe-author/unsubscribe-author'));
const PasswordRecovery = lazy(() => import('./password-recovery/password-recovery'));
const FinishRegistration = lazy(() => import('./finish-registration/finish-registration'));
const FreeDownload = lazy(() => import('./free-download/new-free-download'));
const LoginAs = lazy(() => import('./login-as/login-as'));
const Nps = lazy(() => import('./nps/nps'));
const HomeSchooling = lazy(() => import('./home-schooling/home-schooling'));
const Podcasts = lazy(() => import('./podcasts/podcasts'));
const NotFound = lazy(() => import('../common/not-found/not-found'));
const MySchool = lazy(() => import('./my-school/my-school'));
const AgroNordwest = lazy(() => import('./builder-landings/agro-nordwest/agro-nordwest'));
const AiTools = lazy(() => import('./ai-tools/pages/ai-tools/ai-tools'));
const AiToolPage = lazy(() => import('./ai-tools/pages/ai-tool-page/ai-tool-page'));
const AiToolDocument = lazy(() => import('./ai-tools/pages/ai-tool-document/ai-tool-document'));
const NewInteractive = lazy(() => import('./new-interactive/interactive'));
const SchoolLandingPage = lazy(() => import('./school-landing-page/school-landing-page'));
const AiToolsMyDocuments = lazy(() => import('./ai-tools/pages/ai-tool-my-documents/ai-tools-my-documents'));
const AiToolsFaq = lazy(() => import('./ai-tools/pages/ai-tool-faq/ai-tools-faq'));

const Components = {
    AbandonedCartRedirect,
    Agb,
    AiTools,
    AiToolPage,
    AiToolDocument,
    AiToolsMyDocuments,
    AiToolsFaq,
    GdprJobs,
    AgroNordwest,
    Api,
    Author,
    AuthorRedirect,
    AutoLogin,
    BankDetails,
    Blogpost,
    BuilderPreview,
    Cart,
    ChangeCountry,
    ChangeEmail,
    ChangeEmailConfirm,
    ChangePassword,
    Charts,
    ClimateAction,
    Contact,
    CreateBlogpost,
    CreditNotes,
    Credits,
    DonateUkraine,
    DownloadsList,
    Favorites,
    FillPersonalizationRedirect,
    FinishRegistration,
    Fonts,
    ForgotPassword,
    FreeDownload,
    FreeMaterialsLanding,
    HelpCenter,
    Home,
    HomeSchooling,
    Impressum,
    Inclusion,
    InteractiveMainLanding,
    InvoiceInfo,
    InvoicesAndTaxes,
    NewInteractive,
    Jobs,
    KeywordLanding,
    LMPHistory,
    Landing,
    LoginAs,
    Magazine,
    MailingUnsubscribe,
    MaterialFeedback,
    MaterialCardPreview,
    ImpactPage,
    MentalHealthKidsLanding,
    MentalHealthLanding,
    MentalHealthSurvey,
    MicrosoftRedirectURI,
    MobileAppLanding,
    MySales,
    MySchool,
    MyUploads,
    NewLanding,
    NewMaterialPage,
    NotFound,
    Nps,
    OurTeam,
    Partners,
    PasswordRecovery,
    Payment,
    Podcasts,
    PreferenceCenter,
    Recommendations,
    ReferralsLanding,
    ReferralsLandingForUnauthorized,
    RussiaAttacksUkraineLanding,
    SchoolCreate,
    SchoolWishlist,
    SearchResult,
    Seller,
    SellerSteps,
    SignIn,
    SignUp,
    SignUpConfirm,
    SummerHolidays,
    SwitchLandingComponent,
    ThankYouPage,
    ThankYouPageInvoice,
    Unsubscribe,
    UnsubscribeAuthor,
    Uploads,
    Vouchers,
    Wizard,
    SchoolLandingPage,
    schoolAccount
};

const AsyncComponent = (props) => {
    const { componentName, loadedReducers } = props;

    if (loadedReducers) {
        loadedReducers.forEach(({ path, key }) => {
            import(`./${path}/reducers`).then(({ default: reducer }) => {
                injectReducer(rootStore, { key, reducer });
            });
        });
    }

    const Component = Components[componentName];

    return (
        <Suspense fallback={<div />}>
            <ErrorBoundary withText>
                <Component {...props} />
            </ErrorBoundary>
        </Suspense>
    );
};

export default AsyncComponent;
